
define('modules/application',[

    "app",

    // Libs
    "backbone",
    "moment",
    "magnificPopup",
    "jsbeautifier",

    //Submodules
    "modules/application/dataProvider",
    "modules/application/responseLibrary",
    "modules/application/system-selection-multi",
    "modules/application/system-selection-single",
    "modules/application/quoteTypesMenu",
    "modules/application/header",
    "modules/application/login",
    "modules/application/subheader",
    "modules/application/wizard",
    "modules/application/wizard/classes/accessoryLine",
    //Classes
    "./application/popup",
    //calculationClasses
    "modules/application/calculationClasses/audioVideo",
    "modules/application/calculationClasses/automation",
    "modules/application/calculationClasses/intrusionDetection",
    "modules/application/calculationClasses/thermoregulation",
    "modules/application/calculationClasses/automationSimple",
    "modules/application/calculationClasses/energyManagement",
    //Widgets
    "modules/application/widgets/consumptionIndicator",
    "modules/application/widgets/audioVideoConsumptionIndicator",
    "modules/application/widgets/automationConsumptionIndicator",
    "modules/application/widgets/linkery",
    //wizardservice
    "services/analyticsService",
    "services/WizardServices",
    "services/keepAliveServices",
    "services/md5Services"
  ],

  function(app, Backbone, Moment, MagnificPopup, Jsbeautifier, DataProvider, ReponseLibrary, SystemSelectionMulti, SystemSelectionSingle, QuoteTypesMenu, Header, Login, Subheader, Wizard, AccessoryLine, Popup, AudioVideoCC, AutomationCC, IntrusionDetectionCC, ThermoregulationCC, automationSimpleCC, energyManagementCC, ConsumptionIndicator, AudioVideoConsumptionIndicator, AutomationConsumptionIndicator, Linkery, AnalyticsServices, WizardServices, KeepAliveServices, md5Services) {


    //Setting up namespace
    window.BticinoS4B = {
      Classes: {}
    };

    //Setting up views
    var BticinoS4B = window.BticinoS4B;

    BticinoS4B.browserLanguage = navigator.language || navigator.userLanguage;

    //Server requests urls
    
    BticinoS4B.baseUrl            = window.configuration && window.configuration.baseUrl ? window.configuration.baseUrl : window.location.href;
    BticinoS4B.token              = window.configuration && window.configuration.token   ? window.configuration.token   : '';
    BticinoS4B.devMode            = {};
    BticinoS4B.devMode.enabled    = window.configuration && window.configuration.devMode ? window.configuration.devMode : false;
    BticinoS4B.mailManager        = {};
    BticinoS4B.mailManager.sender = window.configuration && window.configuration.mailManagerSender ?  window.configuration.mailManagerSender : 'softwareforbusiness@bticino.com';
    BticinoS4B.mailManager.smtp   = window.configuration && window.configuration.mailManagerSmtp   ?  window.configuration.mailManagerSmtp   : 'localhost';

    BticinoS4B.eventAggregator = _.extend({}, Backbone.Events);

    BticinoS4B.Classes = {};
    BticinoS4B.Instances = {};

    BticinoS4B.Classes.Views = {};
    BticinoS4B.Instances.Views = {};
    BticinoS4B.Instances.Models = {};
    BticinoS4B.Instances.DataProvider = new DataProvider();
    BticinoS4B.Instances.Views.popup = new Popup.View();

    BticinoS4B.Instances.Services = {};
    BticinoS4B.Instances.Services.analyticsServices = AnalyticsServices;
    BticinoS4B.Instances.Services.wizardServices = new WizardServices();
    BticinoS4B.Instances.Services.md5Services = new md5Services();

    BticinoS4B.Instances.Services.keepAliveServices = new KeepAliveServices();
    BticinoS4B.responseLibrary = new ReponseLibrary();
    BticinoS4B.calls = [];
    BticinoS4B.cachedCalls = [];
    BticinoS4B.vars = {};

    BticinoS4B.projects = {};

    BticinoS4B.solution = {};
    BticinoS4B.solution.audioVideo = {};
    BticinoS4B.solution.thermoregulation = {};
    BticinoS4B.solution.automation = {};
    BticinoS4B.solution.intrusionDetection = {};
    BticinoS4B.solution.energyManagement = {};
    BticinoS4B.solution.automationSimple = {};
    BticinoS4B.modelToLoad = {};
    BticinoS4B.modelToExport = {};

    BticinoS4B.solution.audioVideo.inserted = false;
    BticinoS4B.solution.thermoregulation.inserted = false;
    BticinoS4B.solution.automation.inserted = false;
    BticinoS4B.solution.intrusionDetection.inserted = false;
    BticinoS4B.solution.energyManagement.inserted = false;
    BticinoS4B.solution.automationSimple.inserted = false;

    BticinoS4B.Classes.calculationClassAudioVideo = AudioVideoCC;
    BticinoS4B.Classes.calculationClassAutomation = AutomationCC;
    BticinoS4B.Classes.calculationClassIntrusionDetection = IntrusionDetectionCC;
    BticinoS4B.Classes.calculationClassThermoregulation = ThermoregulationCC;
    BticinoS4B.Classes.calculationClassAutomationSimple = automationSimpleCC;
    BticinoS4B.Classes.calculationClassEnergyManagement = energyManagementCC;

    BticinoS4B.solution.automation.kit = '';
    BticinoS4B.solution.energyManagement.kit = '';
    BticinoS4B.solution.automationSimple.kit = '';
    BticinoS4B.solution.intrusionDetection.kit = '';
    BticinoS4B.root = '';

    BticinoS4B.jsbeautifier = Jsbeautifier;

    BticinoS4B.ConversionManager = {};
    BticinoS4B.ConversionManager.d2h = function(d) {
      return d.toString(16);
    };
    BticinoS4B.ConversionManager.h2d = function(h) {
      return parseInt(h, 16);
    };

    BticinoS4B.checkTokenCookie = function() {
      // var that = this;
      // var scadenza = new Date();
      // var tokenCookie = $.cookie('token');
      // var tokenIAM = $.cookie('apex__currentuser');

      // if (window.BticinoS4B.Instances.Models.loginModel.isAuthenticated()) {
      //   //console.log(window.BticinoS4B.Instances.Models.loginModel.get('isSSO'));
      //   //console.log(tokenIAM);
      //   //console.log(tokenCookie);
      //   if (window.BticinoS4B.Instances.Models.loginModel.get('isSSO')) {
      //     if (!tokenIAM) {
      //       //BticinoS4B.eventAggregator.trigger("session:expired", that);
      //       //BticinoS4B.token = '';
      //       //$.removeCookie('token');
      //     }
      //   } else {
      //   if (!tokenCookie) {
      //     BticinoS4B.eventAggregator.trigger("session:expired", that);
      //     BticinoS4B.token = '';
      //     $.removeCookie('token');
      //     $.removeCookie('apex__currentuser');
      //   } else {
      //     scadenza.setMinutes(scadenza.getMinutes() + 30);

      //     $.cookie('token', window.BticinoS4B.token, {
      //       expires: scadenza,
      //       path: '/'
      //     });
      //     $.cookie('apex__currentuser', window.BticinoS4B.token, {
      //       expires: scadenza,
      //       path: '/'
      //     });
      //   }

      //   //}
      // }
      var tokenCookie = $.cookie('token');
      var scadenza = new Date();
      if (window.BticinoS4B.Instances.Models.loginModel.isAuthenticated()){
        if (window.BticinoS4B.Instances.Models.loginModel.get('isSSO')) {
          window.BticinoS4B.Instances.Models.loginModel.get('iam').run();
          window.BticinoS4B.Instances.Models.loginModel.get('iam').refreshSession();
        }else{
          if (!tokenCookie) {
            BticinoS4B.eventAggregator.trigger("session:expired", that);
            BticinoS4B.token = '';
            $.removeCookie('token');
            //$.removeCookie('apex__currentuser');
          } else {
            scadenza.setMinutes(scadenza.getMinutes() + 30);

            $.cookie('token', window.BticinoS4B.token, {
              expires: scadenza,
              path: '/'
            });
            /*
            $.cookie('apex__currentuser', window.BticinoS4B.token, {
              expires: scadenza,
              path: '/'
            });
            */
          }
        }
      }
    };

    // Create a new module
    var Application = app.module();

    // Application Model
    Application.Model = Backbone.Model.extend({
      defaults: {
        currentLanguage: 'ENG',
        /* array dei bus disponibili a DB */
        buses: [{
          id: "1",
          name: "IDS_W1_9134"
        }, {
          id: "2",
          name: "IDS_W1_9135"
        }, {
          id: "3",
          name: "IDS_W1_9136"
        }]
      },

      initialize: function() {
        var that = this;
        /*
        if (BticinoS4B.browserLanguage == 'it') {
          this.set("currentLanguage", 'ITA');
        } else if (BticinoS4B.browserLanguage == 'fr'){
          this.set("currentLanguage", 'FRA');
        } else if ((BticinoS4B.browserLanguage == 'en-US') || (BticinoS4B.browserLanguage == 'en-GB')) {
          this.set("currentLanguage", 'ENG');
        }
        */
        //mod roby
        //Bind on current language changes
        this.bind("change:currentLanguage", this.getDBDictionary);
        this.bind("change:BticinoS4B.modelToLoad", function() {
          console.log("BticinoS4B.modelToLoad");
        });
        //call getDBDictionary the first time
        this.getDBDictionary();

        // this.bind("change:zigbeeInterfaceQuantity", function() {console.log(this.get("zigbeeInterfaceQuantity"));});
        // this.bind("change:scenarioDinModuleQuantity", function() {console.log(this.get("scenarioDinModuleQuantity"));});
      },

      //mod roby
      getDBDictionary: function(e) {
        var currentLanguage = this.get("currentLanguage");
        //if (currentLanguage===undefined) currentLanguage = "ENG";
        //$.i18n.setDictionary(dictionary[currentLanguage]);
        var currentDictionary = this.getDictionary(currentLanguage);
        $.i18n.setDictionary(currentDictionary);
        //console.log(currentDictionary);
        moment.lang(currentLanguage, momentStrings[currentLanguage]);
        moment.lang(currentLanguage);
      },

      startAutomaticCalculation: function() {
        BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").startAutomaticCalculation();
      },

      createConfiguration: function() {
        BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").createConfiguration();
      },

      filterProductsByCatalogAndWizardChoices: function(products) {
        var catalogId = BticinoS4B.Instances.Models.ApplicationModel.get("catalogId");
        var accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");
        var productsLength = BticinoS4B.Instances.Models.ApplicationModel.get("");

        var filteredProducts = [];

        if (accessoryLineId !== "0")
          filteredProducts = _.filter(products, function(product) {
            return ((product.accessoryLineId === accessoryLineId) || ((product.accessoryLineId === "0") && (product.catalogId === catalogId)));
          });
        else
          filteredProducts = _.filter(products, function(product) {
            return ((product.accessoryLineId === accessoryLineId) && (product.catalogId === catalogId));
          });

        return filteredProducts;
      },

      composeProductUrl: function(productCode) {
        if (!BticinoS4B.Instances.Models.ApplicationModel.get("branchLocalizationId")) {
          BticinoS4B.Instances.Models.ApplicationModel.set('branchLocalizationId', 'ITA');
        }
        var branchLocalizationId = window.BticinoS4B.Instances.Models.loginModel.get('isSSO') ? 'ITA' : BticinoS4B.Instances.Models.ApplicationModel.get("branchLocalizationId");

        var asrBaseUrl = "http://www.e-catalogue.legrandgroup.com/export/?showTarif=true#reference=" + productCode;
        var fraBaseUrl = "http://www.e-catalogue.legrandgroup.com/france/?showTarif=true#reference=" + productCode;
        var itaBaseUrl = "http://www.catalogo.bticino.it/BTI-" + productCode + "-IT";

        switch (branchLocalizationId) {
          case 'ITA':
            return itaBaseUrl;
          case 'FRA':
            return fraBaseUrl;
          default:
            return asrBaseUrl;
        }
      },

      composeReadMoreUrl: function(productCode) {
        var homeSystemsLegrandGroup = 'http://www.homesystems-legrandgroup.com/BtHomeSystems/documentsIndex.action?filter=' + productCode;
        return homeSystemsLegrandGroup;
      },

      getAccessoryLineNameAndColor: function(accessoryLineID) {
        var i,
          j,
          tmp,
          accessoryLines = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLines");

        tmp = 'N/D';
        for (i = 0; i < accessoryLines.length; i++) {
          for (j = 0; j < accessoryLines[i].colors.length; j++) {
            if (accessoryLines[i].colors[j].accessoryLineId == accessoryLineID) {
              //console.log(accessoryLines[i].colors[j].accessoryLineId);
              tmp = accessoryLines[i].name + ' ' + (accessoryLines[i].colors[j].name ? accessoryLines[i].colors[j].name : ' ');
            }

          }
        }

        return tmp;
      },

      /************************/
      /*Ajax utilities methods*/
      /************************/
      //mod roby
      getDictionary: function(lang) {
        var DBDictionary = [];
        $.ajax({
          type: "POST",
          datatype: "json",
          contentType: "application/json",
          async: false,
          url: "/WizardService.svc/GetDictionary",
          data: JSON.stringify({
            languageCode: lang
          }),
          success: function(data) {
            for (var i = 0, length = data.length; i < length; i++) {
              DBDictionary[data[i].string_id] = data[i].string_translation;
            }
          }
        });

        return DBDictionary;
      },

      getPackagesByIdWizardChoice: function(idWizardChoice, successCallback, _errorCallback, _async, _otherAccessoryLine) {
        //console.log('application getPackagesByIdWizardChoice');
        var errorCallback,
          async = false,
          accessoryLine = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");
        // if(idWizardChoice=="818")
        //   console.log("wizard 818");
        if (idWizardChoice && successCallback) {
          if (_errorCallback)
            errorCallback = _errorCallback;

          if (_async)
            async = _async;

          if (_otherAccessoryLine)
            accessoryLine = _otherAccessoryLine;

          var ajaxCallSuccessEventHandler = function(data) {
            var systemId = BticinoS4B.Instances.Models.ApplicationModel.get("systemId");
            data.packages = _.filter(data.packages, function(currentPackage) {
              return currentPackage.systemId === systemId;
            });
            successCallback(data);
          };

          var makeAjaxCall = function() {
            $.ajax({
              type: "POST",
              datatype: "json",
              contentType: "application/json",
              async: async,
              url: window.BticinoS4B.baseUrl + "WizardService.svc/getPackagesByIdWizardChoice",
              data: JSON.stringify({
                token: window.BticinoS4B.token,
                idWizardChoice: idWizardChoice,
                accessoryLineId: accessoryLine,
                catalogCode: BticinoS4B.Instances.Models.ApplicationModel.get("catalogId")
              }),

              success: function(data) {
                data.packages = _.sortBy(data.packages, function(iterablePackage) {
                  return Number(iterablePackage.priority);
                });
                BticinoS4B.responseLibrary.setPackagesByIdWizardChoice(idWizardChoice, BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"), data);
                ajaxCallSuccessEventHandler(data);
              },
              error: errorCallback
            });
          };
         
          //Check presence in responseLibrary
          var storedDatas = BticinoS4B.responseLibrary.getPackagesByIdWizardChoice(idWizardChoice, BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));
          if (storedDatas)
            ajaxCallSuccessEventHandler(storedDatas);
          else {
            if (async) {
              var random = Math.floor((Math.random() * 1000) + 1);
              //setTimeout(makeAjaxCall, random);
              makeAjaxCall();
            } else
              makeAjaxCall();
          }
        }
      },

      getPackageByIdPackageClass: function(idPackageClass, successCallback, _async, _errorCallback) {
        //console.log('application getPackageByIdPackageClass');
        var errorCallback,
          async = false;

        if (idPackageClass && successCallback) {
          if (_errorCallback)
            errorCallback = _errorCallback;

          if (_async)
            async = _async;

          var ajaxCallSuccessEventHandler = function(data) {
            var systemId = BticinoS4B.Instances.Models.ApplicationModel.get("systemId");
            data.packages = _.filter(data.packages, function(currentPackage) {
              return currentPackage.systemId === systemId;
            });
            successCallback(data);
          };

          var makeAjaxCall = function() {
            $.ajax({
              type: "POST",
              datatype: "json",
              contentType: "application/json",
              async: async,
              cache: true,
              url: "/WizardService.svc/getPackageByIdPackageClass",
              data: JSON.stringify({
                token: window.BticinoS4B.token,
                idPackageClass: idPackageClass,
                accessoryLineId: BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"),
                catalogCode: BticinoS4B.Instances.Models.ApplicationModel.get("catalogId")
              }),

              success: function(data) {
                BticinoS4B.responseLibrary.setPackagesByIdWizardChoice(idPackageClass, BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"), data);
                ajaxCallSuccessEventHandler(data);
              },
              error: errorCallback
            });
          };

          //Check presence in responseLibrary
          var storedDatas = BticinoS4B.responseLibrary.getPackagesByIdWizardChoice(idPackageClass, BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));
          if (storedDatas)
            ajaxCallSuccessEventHandler(storedDatas);
          else {
            if (async) {
              var random = Math.floor((Math.random() * 1000) + 1);
              setTimeout(makeAjaxCall, random);
            } else
              makeAjaxCall();
          }
        }
      },

      getProducts: function(idPackageClass, successCallback, _async, _errorCallback) {
        //console.log('application getProducts');
        var errorCallback,
          async = false;

        if (idPackageClass && successCallback) {
          if (_errorCallback)
            errorCallback = _errorCallback;

          if (_async)
            async = _async;

          var ajaxCallSuccessEventHandler = function(data) {

            /////////////////////////////////////////////////////////////////
            ///Luca - Modifica richiesta da Giorgio in data 16/1/2013     ///
            /////////////////////////////////////////////////////////////////
            /// Un pacchetto può essere composto da:                      ///
            /// 1# Pacchetti di serie civile corrente x qualsiasi catalogo///
            /// 2# Pacchetti di serie civile 0 solo del catalogo preferenz///
            /////////////////////////////////////////////////////////////////

            //Existance
            var products = data.products;

            var conditionAtLeastOneArticleOfCurrentAccessoryLine = (_.filter(products, function(iterableProduct) {
              return (iterableProduct.accessoryLineId === BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));
            }).length > 0);

            var conditionAllArticlesOfGenericAccessoryLine = (_.filter(products, function(iterableProduct) {
              return ((iterableProduct.accessoryLineId === "0"));
            }).length === products.length);

            //Filters
            products = _.filter(products, function(iterableProduct) {
              return (
                (iterableProduct.accessoryLineId === BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) || //Condizione #1
                (iterableProduct.accessoryLineId === "0") && (iterableProduct.catalogId === BticinoS4B.Instances.Models.ApplicationModel.get('catalogId')) //Condizione #2
              );
            });

            //Condition on filters
            var conditionAtLeastOneArticleWithMnemonic1 = (_.filter(products, function(iterableProduct) {
              return (iterableProduct.mnemonic === 1);
            }).length > 0);

            var conditionAllArticlesWithPrice = (_.filter(products, function(iterableProduct) {
              return ((iterableProduct.price === null) && (iterableProduct.productCode.indexOf("__ND__") !== 0));
            }).length === 0);

            if ((conditionAtLeastOneArticleOfCurrentAccessoryLine || conditionAllArticlesOfGenericAccessoryLine) && conditionAtLeastOneArticleWithMnemonic1 && conditionAllArticlesWithPrice)
              successCallback({
                products: products
              });
          };

          var makeAjaxCall = function() {
            $.ajax({
              type: "POST",
              datatype: "json",
              contentType: "application/json",
              async: async,
              url: "/WizardService.svc/getProducts",
              data: JSON.stringify({
                token: window.BticinoS4B.token,
                idPackageClass: idPackageClass,
                accessoryLineId: BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")
              }),
              success: function(data) {
                BticinoS4B.responseLibrary.setProducts(idPackageClass, BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"), data);
                ajaxCallSuccessEventHandler(data);
              },
              error: errorCallback
            });
          };

          //Check presence in responseLibrary
          var storedDatas = BticinoS4B.responseLibrary.getProducts(idPackageClass, BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));
          if (storedDatas)
            ajaxCallSuccessEventHandler(storedDatas);
          else {
            if (async) {
              var random = Math.floor((Math.random() * 1000) + 1);
              setTimeout(makeAjaxCall, random);
            } else
              makeAjaxCall();
          }
        }
      }

    });

    BticinoS4B.Instances.Models.ApplicationModel = new Application.Model();

    // Application Message Popup View
    BticinoS4B.Instances.Views.MessageView = Popup.View.extend({
      className: "popup message",
      template: "application/popups/message"
    });

    // Loader Popup
    BticinoS4B.Instances.Views.LoaderView = Popup.View.extend({
      className: "popup loader",
      template: "application/popups/loader"
    });

    // Loader Popup
    BticinoS4B.Instances.Views.actuatorWizardView = Popup.View.extend({
      className: "popup actuatorWizard",
      template: "application/popups/actuatorWizardChoice"
    });

    Application.stopBubbling = function(evt) {
      evt.stopPropagation();
    };

    Application.keepAliveService = function() {
      var that = this,
        errorCounter = 0,
        successCallback = function() {
          errorCounter = 0;
        },
        errorCallback = function(objAJAXRequest, exception) {
          errorCounter++;

          if (errorCounter === 3) {
            BticinoS4B.eventAggregator.trigger("connection:interrupted", that);
            clearInterval(that.caller);
            that.caller = null;
          }
        },
        callerObj = {
          type: "GET",
          cache: false,
          url: "/assets/js/keepAlive.js",
          success: successCallback,
          error: errorCallback
        },

        keepAliveCall = function() {
          var r = new XMLHttpRequest();
          r.open(callerObj.type, callerObj.url, true);
          r.onreadystatechange = function() {
            if (r.readyState === 4) {
              if (r.status !== 200) {
                callerObj.error.call();
              } else {
                callerObj.success.call();
              }
            }
          };
          r.send();
        };

      that.caller = setInterval(keepAliveCall, 200000);
    };

    // Application View
    // ----------
    Application.View = Backbone.View.extend({
      id: "container",

      initialize: function() {
        var that = this;
        Application.keepAliveService();
        app.baseURL = Application.baseUrl;
        //BticinoS4B.eventAggregator = Application.EventAggregator;
        app.stopBubbling = Application.stopBubbling;
        //app.wizardServices = Application.wizardServices;
        //app.LoaderView = Application.LoaderView;
        //app.MessageView = Application.MessageView;

        //app.responseLibrary = new Application.ResponseLibrary();

        if (!BticinoS4B.Instances.Models.loginModel)
          BticinoS4B.Instances.Models.loginModel = new Login.Model({
            eventAggregator: BticinoS4B.eventAggregator
          });

        if (!BticinoS4B.Instances.Models.ApplicationModel)
          BticinoS4B.Instances.Models.ApplicationModel = new Application.Model({
            eventAggregator: BticinoS4B.eventAggregator
          });
        if (!BticinoS4B.Instances.Models.QuoteTypesMenuModel)
          BticinoS4B.Instances.Models.QuoteTypesMenuModel = new QuoteTypesMenu.Model({
            eventAggregator: BticinoS4B.eventAggregator
          });
        BticinoS4B.Instances.Models.ApplicationModel.linkery = new Linkery.View();


        if (this.options.kitCode) {
          BticinoS4B.Instances.Models.ApplicationModel.set("kitCode", this.options.kitCode);
        }

        this.loginView = new Login.View({
          model: BticinoS4B.Instances.Models.loginModel,
          eventAggregator: BticinoS4B.eventAggregator
        });


        if (this.options.systemId)
          this.setSystem(_.filter(BticinoS4B.Instances.Models.ApplicationModel.get("systems"), function(system) {
            return (system.id === that.options.systemId);
          })[0]);

        //mod roby
        //$.i18n.setDictionary(dictionary[BticinoS4B.Instances.Models.ApplicationModel.get("currentLanguage")]);

        //Bind on accessory line selection
        BticinoS4B.eventAggregator.unbind('accessoryLine:chosen-reserved', this.accessoryLineChosenEventHandler);
        BticinoS4B.eventAggregator.bind('accessoryLine:chosen-reserved', this.accessoryLineChosenEventHandler, this);

        //Bind on accessory line removal
        BticinoS4B.eventAggregator.unbind('accessoryLine:removed-reserved', this.accessoryLineRemoved);
        BticinoS4B.eventAggregator.bind('accessoryLine:removed-reserved', this.accessoryLineRemoved, this);

        //Bind on main control unit choose
        BticinoS4B.eventAggregator.unbind('mainControlUnit:chosen', this.mainControlUnitChosenEventHandler);
        BticinoS4B.eventAggregator.bind('mainControlUnit:chosen', this.mainControlUnitChosenEventHandler, this);

        //Bind on main control unit removal
        BticinoS4B.eventAggregator.unbind('mainControlUnit:removed', this.mainControlUnitRemovedEventHandler);
        BticinoS4B.eventAggregator.bind('mainControlUnit:removed', this.mainControlUnitRemovedEventHandler, this);

        BticinoS4B.eventAggregator.unbind("autoLogin:completed", this.autoLoginCompletedEventHandler);
        BticinoS4B.eventAggregator.bind("autoLogin:completed", this.autoLoginCompletedEventHandler, this);

        BticinoS4B.eventAggregator.unbind("login:completed", this.loginCompletedEventHandler);
        BticinoS4B.eventAggregator.bind("login:completed", this.loginCompletedEventHandler, this);

        BticinoS4B.eventAggregator.unbind("session:expired", this.sessionExpiredEventhandler);
        BticinoS4B.eventAggregator.bind("session:expired", this.sessionExpiredEventhandler, this);

        BticinoS4B.eventAggregator.unbind("connection:interrupted", this.connectionInterruptedEventHandler);
        BticinoS4B.eventAggregator.bind("connection:interrupted", this.connectionInterruptedEventHandler, this);

        BticinoS4B.eventAggregator.unbind("language:changed", null, this);
        BticinoS4B.eventAggregator.bind("language:changed", this.render, this);

        BticinoS4B.eventAggregator.unbind("system:changed", this.categorySystemEventHandler);
        BticinoS4B.eventAggregator.bind("system:changed", this.categorySystemEventHandler, this);

        that.setupTab();

        $(window).on('resize', that, this.resize);

        //Setting default ajax call parameters
        $.ajaxSetup({
          tryCount: 0,
          retryLimit: 1,
          error: function(objAJAXRequest, exception) {
            //If session token has been expired
            if (objAJAXRequest.responseText) {
              data = $.parseJSON(objAJAXRequest.responseText);
              if (data.Reason)
                if (data.Reason.indexOf("Token") != -1) BticinoS4B.eventAggregator.trigger("session:expired", that);
            }
          }
        });

        //Injecting popup views
        var expiredSessionPopupView = Popup.View.extend({
          className: "popup message",
          template: "application/popups/message",
          closeButton: false
        });

        this.expiredSessionPopup = new expiredSessionPopupView({
          model: {
            title: "IDS_W1_9061",
            description: "IDS_W1_9062",
            callback: this.reloadHomePage
          }
        });

        this.connectionInterruptedPopup = new expiredSessionPopupView({
          model: {
            title: "IDS_W1_9115",
            description: "IDS_W1_9116",
            callback: this.reloadPage
          }
        });

        var successLanguageListCallback = function(data) {
          BticinoS4B.Instances.Models.ApplicationModel.set("languageList", data);
        };
        BticinoS4B.Instances.Services.wizardServices.getLanguageList(successLanguageListCallback);

        BticinoS4B.Instances.Models.loginModel.autoAuthentication();
        if (!window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLines"))
          this.retrieveAccessoryLine();

        //Inserting views
        this.insertView(".popups", this.expiredSessionPopup);
        this.insertView(".popups", this.connectionInterruptedPopup);

      },

      retrieveAccessoryLine: function() {
        var self = this,
          successCallback = function(data) {
            //console.log(data);
            for (var i = 0; i < data.lines.length; i++) {
              for (var j = 0; j < data.lines[i].colors.length; j++) {
                //console.log(data.lines[i].colors[j]);

                if (data.lines[i].colors[j].accessoryLineId == '0') {
                  data.lines[i].colors[j].image = '';
                } else if (data.lines[i].colors[j].accessoryLineId == '4') {
                  data.lines[i].colors[j].image = '/assets/img/4.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '5') {
                  data.lines[i].colors[j].image = '/assets/img/5.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '8') {
                  data.lines[i].colors[j].image = '/assets/img/8.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '13') {
                  data.lines[i].colors[j].image = '/assets/img/13.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '14') {
                  data.lines[i].colors[j].image = '/assets/img/14.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '21') {
                  data.lines[i].colors[j].image = '/assets/img/21.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '31') {
                  data.lines[i].colors[j].image = '/assets/img/31.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '32') {
                  data.lines[i].colors[j].image = '/assets/img/32.jpg';
                } else if (data.lines[i].colors[j].accessoryLineId == '33') {
                  data.lines[i].colors[j].image = '/assets/img/33.jpg';
                }
              }
            }
            retrievedAccessoryLines = data.lines;

            // set the first value as default
            // TODO: per non settare il valore di default
            // alert('system 114: '+window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLines"));
            if (!window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLines")) {
              window.BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLines", retrievedAccessoryLines);
              // window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenLine",retrievedAccessoryLines[1]);
              // window.BticinoS4B.Instances.Models.ApplicationModel.set("choosenColor",retrievedAccessoryLines[1].colors[0]);
              // window.BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId",retrievedAccessoryLines[1].colors[0].accessoryLineId);
            }
            //console.log(window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLines"));

            //self.accessoryLineChosen(retrievedAccessoryLines[1].colors[0].id, retrievedAccessoryLines[1].id);
            return retrievedAccessoryLines;
          },
          failCallback = function(e) {
            //console.log(e);
          };
        window.BticinoS4B.Instances.Services.wizardServices.getAccessoryLines(successCallback, failCallback, self);
      },

      setSystem: function(system) {
        window.BticinoS4B.Instances.Models.ApplicationModel.set("systemId", system.id);
        window.BticinoS4B.Instances.Models.ApplicationModel.set("systemAppName", system.appName);
      },

      getProjectView: function() {
        var viewToInsert;
        var wizardModel = new Wizard.Model();
        BticinoS4B.Instances.Models.ApplicationModel.set("wizardModel", wizardModel);

        if (BticinoS4B.Instances.Models.ApplicationModel.get("systemId")) {

          switch (BticinoS4B.Instances.Models.ApplicationModel.get("systemId")) {
            case "#2":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new ConsumptionIndicator.Model());
              break;

            case "#4":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new ConsumptionIndicator.Model());
              break;

            case "#5+6":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new AudioVideoConsumptionIndicator.Model());
              break;

            case "#13+20":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new AutomationConsumptionIndicator.Model());
              break;

            case "#13":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new AutomationConsumptionIndicator.Model());
              break;

            case "#21":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new AutomationConsumptionIndicator.Model());
              break;
          }
          viewToInsert = new Wizard.View({
            systemId: BticinoS4B.Instances.Models.ApplicationModel.get("systemId"),
            kitCode: BticinoS4B.Instances.Models.ApplicationModel.get("kitCode"),
            eventAggregator: BticinoS4B.eventAggregator,
            model: wizardModel
          });
        } else {
          viewToInsert = new SystemSelectionMulti.View();
        }

        return viewToInsert;
      },
      getProjectSingleView: function() {
        var viewToInsert;
        var wizardModel = new Wizard.Model();
        BticinoS4B.Instances.Models.ApplicationModel.set("wizardModel", wizardModel);
        if (BticinoS4B.Instances.Models.ApplicationModel.get("systemId")) {

          switch (BticinoS4B.Instances.Models.ApplicationModel.get("systemId")) {
            case "#2":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new ConsumptionIndicator.Model());
              break;

            case "#4":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new ConsumptionIndicator.Model());
              break;

            case "#5+6":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new AudioVideoConsumptionIndicator.Model());
              break;

            case "#13+20":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new AutomationConsumptionIndicator.Model());
              break;

            case "#13":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new AutomationConsumptionIndicator.Model());
              break;

            case "#21":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new AutomationConsumptionIndicator.Model());
              break;
          }
          viewToInsert = new Wizard.View({
            systemId: BticinoS4B.Instances.Models.ApplicationModel.get("systemId"),
            kitCode: BticinoS4B.Instances.Models.ApplicationModel.get("kitCode"),
            eventAggregator: BticinoS4B.eventAggregator,
            model: wizardModel
          });
        } else {
          viewToInsert = new SystemSelectionSingle.View();
        }
        return viewToInsert;
      },

      accessoryLineChosenEventHandler: function(accessoryLineId) {
        BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId", accessoryLineId);
        BticinoS4B.eventAggregator.trigger('accessoryLine:chosen');
      },

      accessoryLineRemovedEventHandler: function() {
        BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId", undefined);
        BticinoS4B.eventAggregator.trigger('accessoryLine:removed');
      },

      mainControlUnitChosenEventHandler: function(mainControlUnitModel) {
        BticinoS4B.Instances.Models.ApplicationModel.set("mainControlUnitModel", mainControlUnitModel);
      },

      mainControlUnitRemovedEventHandler: function() {
        BticinoS4B.Instances.Models.ApplicationModel.set("mainControlUnitModel", undefined);
      },

      resize: function(e) {
        e.data.setupTab();
      },

      reloadPage: function() {
        location.reload();
      },
      reloadHomePage: function() {
        window.location.href = BticinoS4B.baseUrl;
      },

      categorySystemEventHandler: function(system) {
        BticinoS4B.vars.system = system;
        this.setSystem(system);

        if (!BticinoS4B.Instances.Models.ApplicationModel.get("systems")) {
          BticinoS4B.Instances.Views.headerView = new Header.View({
            systemId: undefined,
            eventAggregator: BticinoS4B.eventAggregator
          });
        } else {
          BticinoS4B.Instances.Views.headerView = new Header.View({
            systemId: system.id,
            eventAggregator: BticinoS4B.eventAggregator
          });

          switch (system.id) {
            case "#2":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new ConsumptionIndicator.Model());
              break;

            case "#4":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new ConsumptionIndicator.Model());
              break;

            case "#5+6":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new AudioVideoConsumptionIndicator.Model());
              break;

            case "#13+20":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new AutomationConsumptionIndicator.Model());
              break;

            case "#13":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new AutomationConsumptionIndicator.Model());
              break;

            case "#21":
              BticinoS4B.Instances.Models.ApplicationModel.set("consumptionIndicatorModel", new AutomationConsumptionIndicator.Model());
              break;

          }
        }

        this.setView(BticinoS4B.Instances.Views.headerView);

        if (!BticinoS4B.Instances.Models.loginModel.isAuthenticated()) {
          this.insertView(this.loginView);
          this.render();
        } else {

          if (!BticinoS4B.Instances.Models.QuoteTypesMenuModel.isQuoteTypeDefined() && !BticinoS4B.Instances.Models.ApplicationModel.get("forwardProject")) {
            BticinoS4B.Instances.Views.QuoteTypesMenuView = new QuoteTypesMenu.View();
            this.insertView(BticinoS4B.Instances.Views.QuoteTypesMenuView);
            this.render();

          } else {
            if (BticinoS4B.Instances.Models.ApplicationModel.get("systems")) {
              $('#system-selection').remove();
            }
            if (BticinoS4B.Instances.Models.ApplicationModel.get("forwardProject")) {
              BticinoS4B.Instances.Services.wizardServices.duplicateProject(BticinoS4B.Instances.Models.ApplicationModel.get("forwardProject"), this.successProjectForwardCallback);
              BticinoS4B.Instances.Models.ApplicationModel.set("forwardProject", undefined);
            }
            if (BticinoS4B.Instances.Models.QuoteTypesMenuModel.QuoteType() == "s4b") {
              if (BticinoS4B.Instances.Views.subheaderView) {
                delete BticinoS4B.Instances.Views.subheaderView;
              }
              BticinoS4B.Instances.Views.subheaderView = new Subheader.View();
              this.insertView(BticinoS4B.Instances.Views.subheaderView);
              var projectView = this.getProjectView();
              this.insertView(projectView);
              this.render();
            } else if (BticinoS4B.Instances.Models.QuoteTypesMenuModel.QuoteType() == "webapp") {
              var projectSingleView = this.getProjectSingleView();
              this.insertView(projectSingleView);
              this.render();
            }
          }
        }
      },
      successProjectForwardCallback: function(data) {
        console.log(data);
        var that = this;
        var setAccessoryLineColor = function(solutionSystem) {
          if (!window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLines"))
            BticinoS4B.Instances.Views.ApplicationView.__proto__.retrieveAccessoryLine();
          var line = _.filter(window.BticinoS4B.Instances.Models.ApplicationModel.get('accessoryLines'), function(iterableLine) {
            return iterableLine.id === solutionSystem.accessoryLine.line;
          })[0];
          var color = _.filter(line.colors, function(iterableColor) {
            return iterableColor.id === solutionSystem.accessoryLine.color;
          })[0];

          BticinoS4B.Instances.Models.ApplicationModel.set("choosenColor", color);
          BticinoS4B.Instances.Models.ApplicationModel.set("choosenLine", line);
          BticinoS4B.Instances.Models.ApplicationModel.set("accessoryLineId", color.accessoryLineId);
          return true;
        };
        // var projectName = data.get("name");
        // var accessoryLineSelected = false;
        var solutionLoaded = {};
        var nrOfSystemLoaded = 0;
        var systemIDLoaded, systemAppNameLoaded;

        window.BticinoS4B.Instances.Models.ApplicationModel.InsertedProject = [];
        if (data) {
          BticinoS4B.Instances.Models.ApplicationModel.set("projectId", data.id);
          BticinoS4B.Instances.Models.ApplicationModel.set("projectName", data.name);
          BticinoS4B.Instances.Models.ApplicationModel.set("projectCreated", data.creationDate);
          BticinoS4B.Instances.Models.ApplicationModel.set("projectModified", data.lastEditDate);
          BticinoS4B.Instances.Models.ApplicationModel.trigger("change:projectName");

          solutionLoaded = jQuery.parseJSON(data.content);

          if (solutionLoaded.audioVideo) {
            BticinoS4B.solution.audioVideo = solutionLoaded.audioVideo;
            BticinoS4B.modelToLoad.audioVideo = solutionLoaded.audioVideo;
            BticinoS4B.solution.audioVideo.inserted = true;
            setAccessoryLineColor(solutionLoaded.audioVideo);
            nrOfSystemLoaded++;
            systemIDLoaded = "#5+6";
            systemAppNameLoaded = "audiovideo";
          }
          if (solutionLoaded.thermoregulation) {
            BticinoS4B.solution.thermoregulation = solutionLoaded.thermoregulation;
            BticinoS4B.modelToLoad.thermoregulation = solutionLoaded.thermoregulation;
            BticinoS4B.solution.thermoregulation.inserted = true;
            setAccessoryLineColor(solutionLoaded.thermoregulation);
            nrOfSystemLoaded++;
            systemIDLoaded = "#2";
            systemAppNameLoaded = "termoregolazione";
          }
          if (solutionLoaded.automation) {
            BticinoS4B.solution.automation = solutionLoaded.automation;
            BticinoS4B.modelToLoad.automation = solutionLoaded.automation;
            BticinoS4B.solution.automation.inserted = true;
            setAccessoryLineColor(solutionLoaded.automation);
            nrOfSystemLoaded++;
            systemIDLoaded = "#13+20";
            systemAppNameLoaded = "automazione";
          }
          if (solutionLoaded.intrusionDetection) {
            BticinoS4B.solution.intrusionDetection = solutionLoaded.intrusionDetection;
            BticinoS4B.modelToLoad.intrusionDetection = solutionLoaded.intrusionDetection;
            BticinoS4B.solution.intrusionDetection.inserted = true;
            setAccessoryLineColor(solutionLoaded.intrusionDetection);
            nrOfSystemLoaded++;
            systemIDLoaded = "#4";
            systemAppNameLoaded = "antintrusione";
          }

          if (solutionLoaded.automationSimple) {
            BticinoS4B.solution.automationSimple = solutionLoaded.automationSimple;
            BticinoS4B.modelToLoad.automationSimple = solutionLoaded.automationSimple;
            BticinoS4B.solution.automationSimple.inserted = true;
            setAccessoryLineColor(solutionLoaded.automationSimple);
            nrOfSystemLoaded++;
            systemIDLoaded = "#13";
            systemAppNameLoaded = "automazioneSemplice";
          }

          if (solutionLoaded.energyManagement) {
            BticinoS4B.solution.energyManagement = solutionLoaded.energyManagement;
            BticinoS4B.modelToLoad.energyManagement = solutionLoaded.energyManagement;
            BticinoS4B.solution.energyManagement.inserted = true;
            setAccessoryLineColor(solutionLoaded.energyManagement);
            nrOfSystemLoaded++;
            systemIDLoaded = "#21";
            systemAppNameLoaded = "gestioneEnergia";
          }
        }

        BticinoS4B.Instances.Models.ApplicationModel.set("forwardProject", undefined);
        BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteTypeDefined', true);

        if (nrOfSystemLoaded == 1) {
          BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteType', 'webapp');
          window.BticinoS4B.eventAggregator.trigger("system:changed", {
            id: systemIDLoaded,
            appName: systemAppNameLoaded,
            quoteType: 'webapp'
          });
        } else {
          BticinoS4B.Instances.Models.QuoteTypesMenuModel.set('quoteType', 's4b');
          window.BticinoS4B.eventAggregator.trigger("system:changed", {
            id: undefined,
            appName: undefined,
            quoteType: 's4b'
          });
        }
        // window.BticinoS4B.eventAggregator.trigger("zoneValidityUpdate:request");
        // this.hideLoader();
      },

      loginCompletedEventHandler: function(token) {
        //app.token = token;
        app.username = "";
        app.password = "";
        //BticinoS4B.Instances.Models.ApplicationModel.systemSelectionMultiModel = new SystemSelectionMulti.Model();

        if (this.loginView)
          this.loginView.keep = false;

        BticinoS4B.Instances.Models.ApplicationModel.set("currentLanguage", BticinoS4B.Instances.Models.loginModel.get("branchLocalizationId"));
        // this.loginView.remove();

        // this.subheaderView = new Subheader.View();
        // this.insertView(this.subheaderView);
        // this.render();

        // this.wizardView = this.getProjectView();
        // this.insertView(this.wizardView);
        //this.render();
        if (BticinoS4B.Instances.Models.ApplicationModel.get("forwardProject")) {
            BticinoS4B.Instances.Services.wizardServices.duplicateProject(BticinoS4B.Instances.Models.ApplicationModel.get("forwardProject"), this.successProjectForwardCallback);

            if (BticinoS4B.Instances.Models.QuoteTypesMenuModel.get('quoteType') == 'webapp') {
              if (BticinoS4B.modelToLoad && BticinoS4B.modelToLoad.audioVideo) {
                window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.audioVideo);
              } 
              else if (BticinoS4B.modelToLoad && BticinoS4B.modelToLoad.thermoregulation) {
                window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.thermoregulation);
              }
              else if (BticinoS4B.modelToLoad && BticinoS4B.modelToLoad.intrusionDetection) {
                window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.intrusionDetection);
              }
              else if (BticinoS4B.modelToLoad && BticinoS4B.solution.modelToLoad) {
                window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.automation);
              }
              else if (BticinoS4B.modelToLoad && BticinoS4B.solution.modelToLoad) {
                window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.automationSimple);
              }
              else if (BticinoS4B.modelToLoad && BticinoS4B.solution.modelToLoad) {
                window.BticinoS4B.eventAggregator.trigger("load:Project", BticinoS4B.modelToLoad.energyManagement);
              }
            }
          }
          else
            { BticinoS4B.Instances.Router.quoteTypesMenu(); }
      },

      autoLoginCompletedEventHandler: function() {
        app.username = "";
        app.password = "";
        // if(BticinoS4B.Instances.Models.QuoteTypesMenuModel.isQuoteTypeDefined && BticinoS4B.Instances.Models.QuoteTypesMenuModel.QuoteType()=="webapp")
        //     BticinoS4B.Instances.Models.ApplicationModel.systemSelectionSingleModel = new SystemSelectionSingle.Model();
        // else
        //     BticinoS4B.Instances.Models.ApplicationModel.systemSelectionMultiModel = new SystemSelectionMulti.Model();

        if (this.loginView)
          this.loginView.keep = false;

        BticinoS4B.Instances.Models.ApplicationModel.set("currentLanguage", BticinoS4B.Instances.Models.loginModel.get("branchLocalizationId"));
        this.render();
      },

      sessionExpiredEventhandler: function() {
        this.expiredSessionPopup.show();
      },

      connectionInterruptedEventHandler: function() {
        this.connectionInterruptedPopup.show();
      },

      setupTab: function() {
        var header = $("body").find("header");
        var subheader = $("body").find("#subheader");
        var wizard = $("body").find("#wizard");

        wizard.height($("body").height() - header.height() - subheader.height() - 1);

        var stepList = wizard.children(".tabs").children("#stepList");
        var tabs = wizard.find(".tab");

        tabs.each(function(index) {
          $(this).height(wizard.height() - stepList.height());

          var itemView = $(this).find(".itemContent");
          var menuView = $(this).find(".menu");
          var topBarView = $(this).find(".topBar");
          var genericInfoView = $(this).find(".genericInfo");
          var footer = $(this).find("footer");

          itemView.height($(this).height() - 44 - footer.height() - genericInfoView.height());
          menuView.height($(this).height() - 44 - footer.height());

          var menuContentView = menuView.find(".content");
          var menuTitleView = menuView.find(".titleBar");
          var menuZoneListView = menuView.find(".zones");

          menuContentView.height(menuView.height());
          menuZoneListView.height(menuContentView.height() - 0);

        });
      },

      afterRender: function() {
        this.setupTab();
        window.customizeFormElements.call();
        this.setupTab();
      },

      onClose: function() {}
    });


    // Required, return the module for AMD compliance
    return Application;

  });